import { selectProjectForSaving, selectProjectThumbnail } from '~/selectors/projectData'
import { createProject } from './createProject'

export const saveProjectAs = projectName => async (dispatch, getState) => {
  const state = getState()
  const project = selectProjectForSaving(state)
  const thumbnail = selectProjectThumbnail(state)
  const createdProjectId = await dispatch(
    createProject(JSON.stringify(project), projectName, thumbnail, project.createTime, {
      updateProjectFileRefCount: true,
    })
  )

  return createdProjectId
}
